<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">
        Введіть номер договору
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">
        Информація за договором
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">До сплати</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card>
          <p>
            Погашення відсотків за договором ON LINE – новий сервіс компанії
            Мідас. Для виконання оплати Вам потрібно знати номер договору і мати
            банківську карту або сервіс Приват24.
          </p>
          <v-alert class="deep-orange lighten-2" dark>
            <span class="title mr-5">Увага!</span>
            <span class="black--text"
              >Договір буде пролонговано до {{ formatDate(addDays(date, 10)) }}
            </span>
          </v-alert>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit="getReceipt"
          >
            <v-row>
              <v-col cols="12" sm="6" md="7"
                ><v-text-field
                  v-model="contractNumber"
                  :rules="contractNumberRules"
                  outlined
                  :readonly="loading"
                  label="Номер договору"
                  required
                  ref="contractNumber"
                  clearable
                ></v-text-field
              ></v-col>
              <v-col cols="6" sm="6" md="5"
                ><v-btn
                  :disabled="!valid"
                  x-large
                  :loading="loading"
                  color="success"
                  @click="getReceipt"
                >
                  Отримати суму відсотків
                </v-btn></v-col
              >
            </v-row>

            <div v-if="error">
              <v-alert type="error"> {{ error }} </v-alert>
            </div>

            <div>
              <v-row justify="center" align="center">
                <v-col cols="6" sm="6" md="4">
                  <h2
                    class="deep-orange lighten-2 pa-10 text-center white--text"
                  >
                    Зверніть увагу!
                  </h2>
                </v-col>
                <v-col cols="6" sm="6" md="8"
                  ><v-alert dense outlined prominent color="#ff835d">
                    <v-row align="center">
                      <v-col class="grow">
                        <ul class="">
                          <li class="black--text">
                            мінімальна сума до погашення – всі нараховані
                            відсотки на момент оплати;
                          </li>
                          <li class="black--text">
                            online оплата доступна тільки в період дії договору
                            + 7 календарних днів. Починаючи з 8-го дня
                            прострочення, оплата доступна тільки в відділенні
                            мережі ломбардів «Мідас»;
                          </li>
                          <li class="black--text">
                            оплата на сайті гарантує пролонгацію договору на 10
                            днів, після закінчення яких клієнт зобов’язаний
                            оплатити % на відділенні (пролонгація від 1 до 31
                            дня), або на сайті (пролонгація на 10 днів);
                          </li>
                          <li class="black--text">
                            для повного закриття (погашення) кредиту і викупу
                            виробу, необхідно звернутися у відділення.
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </v-alert></v-col
                >
              </v-row>
            </div>

            <!-- <v-btn color="primary" :disabled="!valid" @click="validate"> Отримати суму відсотків </v-btn> -->
          </v-form>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2" v-if="paymentCard">
        <v-card flat>
        <!-- <v-card> -->
        <p class="display-1 text--primary">
          {{ paymentCard.Lastname }} {{ paymentCard.Firstname }}
          {{ paymentCard.Middlename }}
        </p>
        <div class="text--primary">
          <h2>
            Номер договору:
            <span class="font-weight-bold">{{ contractNumber }}</span>
          </h2>
          <h2>
            Сума боргу:
            <span class="font-weight-bold">{{
              paymentCard.AmountOfInterest
            }}</span>
          </h2>
        </div>
      
        </v-card>
        <div class="my-2">
          <v-checkbox
              v-model="agree"
              label="З даними погоджуюсь"
              color="info"
              value="1"
              hide-details
            ></v-checkbox>
        </div>
        <div class="my-5">
          <div class="float-right" v-html="liqpayButton" :class="!agree ? 'not-confirmed' : ''"></div>
          <v-btn large color="success" @click="e1 = 1"> Назад </v-btn>
        </div>
        <!-- </v-card> -->
      </v-stepper-content>

      <!-- <v-stepper-content step="3">
        <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>

        <v-btn color="primary" @click="e1 = 1"> Continue </v-btn>

        <v-btn text> Cancel </v-btn>
      </v-stepper-content> -->
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  name: "PaymentCard",
  data: () => ({
    info: null,
    e1: 1,
    date: new Date(),

    agree: false,

    valid: false,
    contractNumber: "",
    contractNumberRules: [(v) => !!v || "Вкажіть номер договору"],
  }),
  methods: {
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    formatDate(date) {
      var month = "" + (date.getMonth() + 1),
        day = "" + date.getDate(),
        year = date.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return day + "/" + month + "/" + year;
    },
    validate() {
      this.$refs.form.validate();
      //console.log(this.valid);
      if (this.valid === true) {
        this.e1 = 2;
      }
      // this.e1 = 2
    },
    async getReceipt(e) {
      e.preventDefault();

      this.$store.dispatch("axios1c/clearError");

      try {
        await this.$store.dispatch("axios1c/getPaymentCard", {
          paymentCard: this.contractNumber,
        });
      } catch (err) {
        console.log(err);
      }

      // console.log('vue');
      // // console.log('vue');
      // console.log(this.paymentCard);
   
      //console.log(this.paymentCard.AgreementDate);


      if (this.paymentCard) {
        // console.log("next_page");
        this.e1 = 2;
        this.agree = false;

        this.getLiqpayButton(
        parseFloat(
          this.paymentCard.AmountOfInterest.replace(/\s/g, "").replace(/,/, ".")
        ).toFixed(2)
      );
      }
    
    },
    async getLiqpayButton(amount) {
      try {
        await this.$store.dispatch("axios1c/getLiqpayButton", {
          amount: amount,
          description: "Сплата за договором " + this.contractNumber,
          cardId: this.paymentCard.AgreementUUID
        });
      } catch (err) {
        console.log(err);
      }

      //console.log("payment_card:" + this.paymentCard);
      if (this.paymentCard) {
        //console.log("next_page");
        this.e1 = 2;
      }
      //console.log("payment_card2:" + this.paymentCard);
    },
    focusInput() {
      this.$refs.contractNumber.focus();
    },
  },
  mounted() {
    this.valid = false;
  },
  computed: {
    loading() {
      return this.$store.getters["axios1c/returnLoading"];
    },
    error() {
      return this.$store.getters["axios1c/returnError"];
    },
    paymentCard() {
      return this.$store.getters["axios1c/returnPaymentCard"];
    },
    liqpayButton() {
      return this.$store.getters["axios1c/returnLiqpayButton"];
    },
  },
};
</script>
<style>
.black--text::marker {
  color: #ff7043;
}
.not-confirmed {
  pointer-events: none;  
}
.not-confirmed input {
opacity: 0.2;
}
</style>